const SLICES = {
    USER: 'user',
    MOVIE: 'movie'
};

export {
    SLICES
};
